import { render, staticRenderFns } from "./marketing.vue?vue&type=template&id=679de6fa&scoped=true"
import script from "./marketing.vue?vue&type=script&lang=js"
export * from "./marketing.vue?vue&type=script&lang=js"
import style0 from "./marketing.vue?vue&type=style&index=0&id=679de6fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679de6fa",
  null
  
)

export default component.exports